import { ThemeEvents } from '@theme/events';

window.addEventListener('load', () => {
    function processAutoSelectedInputs() {
        const variantPicker = document.querySelector('variant-picker');
        if (!variantPicker) return;

        const form = variantPicker.querySelector('form.variant-picker__form');
        if (!form) return;

        const changeEvent = new Event('change', {
        bubbles: true,
        cancelable: true
        });

        const fieldsets = form.querySelectorAll('fieldset');
        for (const fieldset of fieldsets) {
        const fieldsetInputs = fieldset.querySelectorAll('input[type="radio"]');
        let hasChecked = false;
        for (const input of fieldsetInputs) {
            if (input.checked) {
            hasChecked = true;
            }
        }
        if(!hasChecked){
            fieldsetInputs[0].checked = true
            fieldsetInputs[0].dispatchEvent(changeEvent);
        }
        }
    }

    document.addEventListener(ThemeEvents.variantUpdate, (event) => {
        setTimeout(() => {
            processAutoSelectedInputs();
        }, 100);
    });

    setTimeout(() => {
        processAutoSelectedInputs();
    }, 500);
});